import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './Caroussel.css';

const Carousel = ({ images }) => {
  // Configuration du carousel
  const settings = {
    dots: true, // Affiche les indicateurs de position
    infinite: true, // Boucle infinie
    speed: 500, // Vitesse de transition
    slidesToShow: 1, // Nombre d'images visibles
    slidesToScroll: 1, // Nombre d'images à faire défiler
    autoplay: true, // Défilement automatique
    autoplaySpeed: 3000, // Délai entre les transitions (3 secondes)
    arrows: true, // Affiche les flèches de navigation
    centerMode: true, // Centre l'image active
    centerPadding: '0', // Supprime le padding autour de l'image centrée
  };

  return (
    <div className="carousel-container">
      <Slider {...settings}>
        {images.map((image, index) => (
          <div key={index} className="carousel-slide">
            <img
              src={image.src}
              alt={image.alt || `Slide ${index + 1}`}
              className="carousel-image"
            />
            {image.caption && (
              <p className="carousel-caption">{image.caption}</p>
            )}
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Carousel;
